module.exports = __webpack_public_path__ + "static/media/435_Kitchen2.d21ec7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Kitchen2.jpg
// module id = 563
// module chunks = 0